import { useState } from "react";

import type { OpenAPI } from "simplydo/interfaces";

import IdeaBusinessProfileModal from "../IdeaBusinessProfileModal/IdeaBusinessProfileModal";
import BaseChip, { type ChipConfiguration } from "./BaseChip";

const IdeaBusinessProfileChip = ({
  ideaBusinessProfile,
  ...props
}: ChipConfiguration & {
  ideaBusinessProfile: OpenAPI.Schemas["IdeaBusinessProfile"];
}) => {
  const [viewingProfile, setViewingProfile] = useState(false);

  if (!ideaBusinessProfile) {
    return null;
  }
  return (
    <>
      {viewingProfile ?
        <IdeaBusinessProfileModal
          businessProfile={ideaBusinessProfile}
          onClose={() => setViewingProfile(false)}
        />
      : null}
      <BaseChip
        {...props}
        style={{ maxWidth: 200 }}
        title={ideaBusinessProfile.name}
        subtitle={ideaBusinessProfile.websiteUrl}
        {...(ideaBusinessProfile.imageUrl ?
          { imageUrl: ideaBusinessProfile.imageUrl }
        : { icon: "building" as const })}
        onClick={() => setViewingProfile(true)}
        avatarBorderRadius={4}
        avatarBackgroundSize="contain"
        chipBorderRadius={8}
      />
    </>
  );
};

export default IdeaBusinessProfileChip;
